<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-07-26 10:50:42
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-11 13:43:38
 * @FilePath: /chaoyongtuan/src/views/secondColonelManage/myActivities/detail/components/confirmDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog :visible.sync="visible" :title="title" width="326px">
		<p class="fz-14">{{ content }}</p>
		<div slot="footer" class="dialog-footer">
			<el-button @click="visible = false">取 消</el-button>
			<el-button type="primary" @click="confirm">确 认</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { ksActivityCloseKs, ksActivityDelKs } from '@/api/secondColonelManage';
export default {
	data() {
		return {
			visible: false,
			activity_id: '',
			title: '',
			content: '',
			type: '',
			authorityId: '',
		};
	},
	methods: {
		show(title, activity_id, content, type, authorityId) {
			this.content = content;
			this.title = title;
			this.type = type;
			(this.activity_id = activity_id), (this.authorityId = authorityId);
			this.visible = true;
		},
		async confirm() {
			const { activity_id, type, authorityId: authority_id } = this;
			if (type) {
				const { code } = await ksActivityCloseKs({ activity_id, authority_id });
				if (code !== 0) return;
				this.$emit('refresh', 1);
			} else {
				const { code } = await ksActivityDelKs({ activity_id, authority_id });
				if (code !== 0) return;
				this.$emit('refresh', 0);
			}
			this.$message.success('操作成功');
			this.visible = false;
		},
	},
};
</script>
